import config from '../../config';
import React from 'react';
import { branch } from 'baobab-react/higher-order';
import Helmet from 'react-helmet';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';
import Header from '../common/Header';
import InputSlider from 'react-input-slider';
import Tooltip from '../common/Tooltip';
import { Link } from 'react-router';
import Option from './common/SafeSelectorOption';

class Capacity extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			facet: 'size',
			selectedSize: '',
			selectedSizeIndex: '',
			x: 0,
			btnDisabled: true
		};
	}

	componentDidMount() {
		this.setState({
			selectedSize: sessionStorage.getItem('selectedSize'),
			selectedSizeIndex: sessionStorage.getItem('selectedSizeIndex'),
			x: sessionStorage.getItem('selectedSizeIndex') === null ?
				0 : parseInt(sessionStorage.getItem('selectedSizeIndex'),10),
			btnDisabled: sessionStorage.getItem('selectedSize') === null
		});
		sessionStorage.removeItem('selectedLockType');
		sessionStorage.removeItem('selectedProtection');
	}

	handleSliderChange(pos) {
		this.setState({
			x: pos.x
		});
	}

	handleInputChange(e) {
		const index = e.target.dataset.index;
		this.setState({
			selectedSize: e.target.value,
			selectedSizeIndex: parseInt(index,10),
			x: parseInt(index,10),
			btnDisabled: false
		});
	}

	handleSubmit(e) {
		const { selectedSize, selectedSizeIndex, btnDisabled } = this.state;
		if (btnDisabled) {
			e.preventDefault();
		} else {
			sessionStorage.setItem('selectedSize', selectedSize);
			sessionStorage.setItem('selectedSizeIndex', selectedSizeIndex);
			global.dataLayer.push({
				event: 'Product Selector',
				eventCategory: 'Product Selector',
				eventAction: 'Continue - Step 2',
				eventLabel: global.location.pathname
			});
		}
	}

	handleSkip() {
		sessionStorage.removeItem('selectedSize');
		global.dataLayer.push({
			event: 'Product Selector',
			eventCategory: 'Product Selector',
			eventAction: 'Skip - Step 2',
			eventLabel: global.location.pathname
		});
	}

	render() {
		const { facet, btnDisabled, x } = this.state;

		const options = this.props.facets.filter(item => {
			return item.value === facet ? item : '';
		})[0].items.map((item, index) => {
			const { name, value } = item;
			const obj = {
				id: index + 1,
				name,
				value
			};

			if (item.name === 'Extra Small') {
				obj.name = 'XS';
			} else if (item.name === 'Small') {
				obj.name = 'S';
			} else if (item.name === 'Medium') {
				obj.name = 'M';
			} else if (item.name === 'Large') {
				obj.name = 'L';
			} else if (item.name === 'Extra Large') {
				obj.name = 'XL';
			} else if (item.name === 'XX-Large') {
				obj.name = 'XXL';
			}

			return obj;
		});

		const sizes = options.map((item, index) => {
			return (
				<Option
					key={ index }
					id={ `size${item.id}` }
					name="safeSize"
					value={ item.value }
					index={ item.id }
					checked={ this.state.selectedSize === item.value }
					onChange={ e => this.handleInputChange(e) }
					onClick={ e => this.handleInputChange(e) }
					label={ item.name }
					trackEventAction="Capacity"
					trackEventLabel={ item.value }
				/>
			);
		});

		const imgUrl = `${config.contentUrl}/sentrysafe/stacked`;
		const Stack = () => {
			let src = `${imgUrl}/C1.png`;
			if (x === options.length - 4) {
				src = `${imgUrl}/C1.png`;
			} else if (x === options.length - 3) {
				src = `${imgUrl}/SS1.png`;
			} else if (x === options.length - 2) {
				src = `${imgUrl}/SS5.png`;
			} else if (x === options.length - 1) {
				src = `${imgUrl}/S2.png`;
			} else if (x === options.length) {
				src = `${imgUrl}/S6.png`;
			}
			return (
				<figure>
					<img src={ src } alt="stack" />
				</figure>
			);
		};

		return (
			<div className="safe-selector">
				<Helmet>
					<title>Safe Selector | SentrySafe</title>
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Safe Selector" />
				</Breadcrumb>

				<div className="steps-progress">
					<ol>
						<li className="on active">
							<span>Capacity</span>
						</li>
						<li>
							<span>Lock Type</span>
						</li>
						<li>
							<span>Protection</span>
						</li>
						<li>
							<span>Results</span>
						</li>
					</ol>
				</div>

				<Header
					title="What’s the best size for your needs?"
					description="Image reflects approximate internal capacity."
				/>

				<span className="arrow-down" />

				<div className="section section-select-safe-capacity pt-2 pb-5">
					<div className="section-content row text-center">
						<div className="col">
							<Stack />

							<InputSlider
								className="capacity-slider"
								axis="x"
								x={ this.state.x }
								xstep={ 1 }
								xmin={ 1 }
								xmax={ options.length }
								onChange={ pos => this.handleSliderChange(pos) }
								onClick={ pos => this.handleSliderChange(pos) }
								onDragEnd={ () => {
									global.dataLayer.push({
										event: 'Product Selector',
										eventCategory: 'Product Selector',
										eventAction: 'Slider',
										eventLabel: this.state.x
									});
								} }
							/>

							<div className="safe-selector-options">
								{ sizes }
							</div>

							<ul className="list-unstyled m-0 safe-selector-actions">
								<li>
									{
										btnDisabled ? 
											<Tooltip
												trigger={
													<Link
														className="btn btn-primary disabled"
														to="#"
														onClick={ e => this.handleSubmit(e) }
													>
														Continue
													</Link>
												}
												content="For the best results, please select an option."
											/>
											:
											<Link
												className="btn btn-primary"
												to="/safe-selector/lock-type"
												onClick={ e => this.handleSubmit(e) }
											>
												Continue
											</Link>
									}
								</li>
								<li />
								<li>
									<Link
										to="/safe-selector/lock-type"
										onClick={ () => this.handleSkip() }
									>
										Skip
									</Link>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		);
	}
};

export default branch({
	facets: ['productSearchResults', 'facets']
}, Capacity);


// WEBPACK FOOTER //
// ./src/pages/safeSelector/Capacity.js